// All Anschrift fields are individually nullish — assembles a single-line string from whatever is present.
type Anschrift = {
    hausnummer?: string | null;
    land?: string | null;
    ort?: string | null;
    plz?: string | null;
    strasse?: string | null;
};

export function formatApplicantAddress(anschrift: Anschrift | null | undefined): string | null {
    if (!anschrift) return null;

    const streetLine = [anschrift.strasse, anschrift.hausnummer].filter(Boolean).join(' ');
    const cityLine = [anschrift.plz, anschrift.ort].filter(Boolean).join(' ');
    const parts = [streetLine, cityLine, anschrift.land].filter((part) => Boolean(part && part.trim().length > 0));

    return parts.length > 0 ? parts.join(' • ') : null;
}
